import service from "@/utils/request";

// 配置开关详情
export const switchDetailApi = () => {
  return service({
    url: "/api/v1/org/config/switch_detail",
    method: "get",
  });
};

export interface switchModifyInter {
  key: string;
  status: number;
}

// 开关设置
export const switchModifyApi = (data: switchModifyInter) => {
  return service({
    url: "/api/v1/org/config/switch_modify",
    method: "post",
    data,
  });
};

// 组织下机构列表
export const getInstOrgListApi = () => {
  return service({
    url: "/api/v1/org/inst_list",
    method: "get",
  });
};

// 来源渠道列表（已弃用）
export const sourceTypeListApi = () => {
  return service({
    url: "/api/v1/student/source_type/list",
    method: "get",
  });
};
// 添加来源渠道（已弃用）
export const sourceTypeAddApi = (data: { name: string; sort?: number }) => {
  return service({
    url: "/api/v1/student/source_type/add",
    method: "post",
    data,
  });
};
// 编辑来源渠道（已弃用）
export const sourceTypeEditApi = (data: {
  student_source_id: number;
  name: string;
  sort?: number;
}) => {
  return service({
    url: "/api/v1/student/source_type/edit",
    method: "post",
    data,
  });
};
// 删除来源渠道（已弃用）
export const sourceTypeDelApi = (params: { student_source_id: number }) => {
  return service({
    url: "/api/v1/student/source_type/del",
    method: "get",
    params,
  });
};
// 来源渠道列表 - 新
export const sourceTypeSelectListApi = (params?: {
  appear_id?: number;
  status?: number;
}) => {
  return service({
    url: "/api/v1/student/source/list",
    method: "get",
    params,
  });
};
// 跟进阶段KV列表
export const followStageApi = () => {
  return service({
    url: "/api/v1/student/follow/stage",
    method: "get",
  });
};
// 学员超上总数
export const courseExceedTotalApi = () => {
  return service({
    url: "/api/v1/student/course/exceed_total",
    method: "get",
  });
};

// 意向学员配置列表
export const getIntentionStudentConfigApi = () => {
  return service({
    url: "/api/v1/org/intention_student_config/list",
    method: "get",
  });
};
// 意向学员配置编辑
export const editIntentionStudentConfigApi = (data: {
  config_key: string;
  switch: number;
  exceed_day?: number;
}) => {
  return service({
    url: "/api/v1/org/intention_student_config/edit",
    method: "post",
    data,
  });
};
// 学员出现方式
export const getStudentAppearListApi = (params: {
  page?: number;
  page_size?: number;
  status?: number;
}) => {
  return service({
    url: "/api/v1/student/appear/list",
    method: "get",
    params,
  });
};
